import withZoomInOut from './withZoomInOut';
export default withZoomInOut;
